if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
        if (window.location.href.includes("/products/")) {
          this.addRecentlyViewed();
        }
        this.mql = window.matchMedia("(min-width: 751px)");
        document.addEventListener("DOMContentLoaded", () => {
          this.productPolicies =
            document.querySelectorAll(".product__policies");
          this.productPolicies.forEach((p) => {
            p.addEventListener("click", this.viewProductPolicy.bind(this, p));
          });
        });
      }

      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true }),
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      async addRecentlyViewed() {
        const itemHandle =
          document.getElementsByClassName("product__title")[0]?.id;
        let finalItems = [];
        if (__st.cid) {
          const items = await fetch(
            `https://api.givadiva.co/v2/omnichannel/viewedProducts?user_shopify_id=${__st.cid}`,
          ).then((res) => res.json());
          finalItems = items.data;
          if (items.data && !items.data.includes(itemHandle)) {
            fetch("https://api.givadiva.co/v2/omnichannel/productView", {
              method: "POST",
              body: JSON.stringify({
                user_shopify_id: `${__st.cid}`,
                handle: itemHandle,
              }),
              headers: { "Content-Type": "application/json" },
            }).then((e) => {
              console.log(e);
            });
          }
        }
        let recentlyViewedList = [];
        if (localStorage.getItem("recentlyViewedObj")) {
          recentlyViewedList = localStorage
            .getItem("recentlyViewedObj")
            .split(",");
          finalItems = recentlyViewedList;
          if (recentlyViewedList.includes(itemHandle)) {
            recentlyViewedList.splice(
              recentlyViewedList.indexOf(itemHandle),
              1,
            );
          }
          if (recentlyViewedList.length === 10) {
            recentlyViewedList.shift();
          }
        }
        recentlyViewedList.push(itemHandle);
        localStorage.setItem("recentlyViewedObj", recentlyViewedList);
        if (finalItems.length > 0) {
          const element = document.getElementById("Slider-recently-viewed");
          Promise.allSettled(
            finalItems.map((p) =>
              fetch(`/products/${p}?view=card`)
                .then((r) => r.text())
                .then((res) => {
                  const text = res;
                  const parser = new DOMParser();
                  const htmlDocument = parser.parseFromString(
                    text,
                    "text/html",
                  );
                  const productCard =
                    htmlDocument.documentElement.querySelector(
                      ".template-card",
                    );
                  if (productCard) {
                    return productCard.innerHTML;
                  } else {
                    return null;
                  }
                }),
            ),
          ).then((cards) => {
            const finalProds = cards.filter((s) => s.value != null);
            if (document.getElementsByClassName("recently-viewed-prods")[0]) {
              if (finalProds.length > 0) {
                document.getElementsByClassName(
                  "recently-viewed-prods",
                )[0].style.display = "block";
                finalProds.forEach((prod, index) => {
                  const finalHtml = `<li
                  class="grid__item slider__slide{% if settings.animations_reveal_on_scroll %} scroll-trigger animate--slide-in{% endif %}"
                  id="Slide-recently-viewed-${index}"
                  {% if settings.animations_reveal_on_scroll %}
                    data-cascade
                    style="--animation-order: ${index};"
                  {% endif %}
                >
                  ${prod.value}
                </li>`;
                  if (element) element.innerHTML += finalHtml;
                });
                const customSlider = document.getElementById(
                  "recently_viewed_component",
                );
                if (
                  customSlider &&
                  typeof customSlider.initSlider === "function"
                ) {
                  customSlider.initSlider();
                }
              } else {
                document.getElementsByClassName(
                  "recently-viewed-prods",
                )[0].style.display = "none";
              }
            }
          });
        } else {
          if (document.getElementsByClassName("recently-viewed-prods")[0]) {
            document.getElementsByClassName(
              "recently-viewed-prods",
            )[0].style.display = "none";
          }
        }
      }

      viewProductPolicy(policy) {
        const activePolicy = document.getElementsByClassName(
          "active_product_policy",
        )[0];
        const tag = policy.querySelector(".tag");
        if (activePolicy) {
          activePolicy.querySelector(".tag").innerHTML = tag.innerHTML;
          Array.from(activePolicy.getElementsByTagName("img")).forEach(
            (element) => {
              element.style.display = "none";
            },
          );
          if (tag.innerHTML === "100% Certified Lab Diamonds") {
            activePolicy.querySelector("#overlay_100_diamond").style.display =
              "block";
            activePolicy.querySelector("p").innerHTML =
              "Top-quality, eco-friendly premium<br>lab-grown diamonds, certified by<br>SGL/IGI.";
          } else if (tag.innerHTML === "BIS Hallmark") {
            activePolicy.querySelector("#overlay_bis").style.display = "block";
            activePolicy.querySelector("p").innerHTML =
              "100% purity assured with the BIS<br>hallmark on all our gold jewellery.";
          } else if (tag.innerHTML === "Lifetime Exchange &amp; Buyback") {
            activePolicy.querySelector("#overlay_buyback").style.display =
              "block";
            activePolicy.querySelector("p").innerHTML =
              "Guaranteed lifetime exchange and<br>buyback for GIVA gold and<br>diamonds at current market prices.";
          } else if (tag.innerHTML === "Easy 15 Day Return") {
            if (tag.dataset.prodType === "gold") {
              activePolicy.querySelector(
                "#overlay_30_days_gold",
              ).style.display = "block";
            } else {
              activePolicy.querySelector("#overlay_30_days").style.display =
                "block";
            }
            activePolicy.querySelector("p").innerHTML =
              "Don't worry, we offer a no-<br>questions-asked, easy 15-day<br>return policy for GIVA jewellery.";
          } else if (tag.innerHTML === "Lifetime Plating") {
            activePolicy.querySelector("#overlay_plating").style.display =
              "block";
            activePolicy.querySelector("p").innerHTML =
              "GIVA promises everlasting shine with the free lifetime plating service on silver jewellery.*";
          } else if (tag.innerHTML === "6-Month Warranty") {
            activePolicy.querySelector("#overlay_warranty").style.display =
              "block";
            activePolicy.querySelector("p").innerHTML =
              "Enjoy added assurance with our 6-month warranty on all of GIVA’s silver jewellery.";
          } else if (tag.innerHTML === "Fine 925 Silver") {
            activePolicy.querySelector("#overlay_925").style.display = "block";
            activePolicy.querySelector("p").innerHTML =
              "Get an assured 925 silver authenticity certificate with every piece of our silver jewellery.";
          } else if (tag.innerHTML === "999 Silver") {
            activePolicy.querySelector("p").innerHTML =
              "Purity guaranteed - get an assured 999 silver authenticity certificate.";
          }
          activePolicy.style.display = "flex";
          if (this.mql.matches) {
            activePolicy &&
              activePolicy.addEventListener("click", () => {
                activePolicy.style.display = "none";
              });
          } else {
            activePolicy.querySelector("#cross") &&
              activePolicy
                .querySelector("#cross")
                .addEventListener("click", () => {
                  activePolicy.style.display = "none";
                });
          }
        }
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel"),
            ),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]",
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`,
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === "",
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden"),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`,
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`,
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable,
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]"),
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        return fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden"),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products",
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`,
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list",
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}
